import { noop } from 'es-toolkit';
import { PromiseWithResolver } from './PromiseWithResolver';
export default function waitReject(duration, reason = 'TIMED_OUT') {
    let resolve = noop;
    const promise = new PromiseWithResolver((resolver, reject) => {
        const timeoutId = setTimeout(() => reject(reason), duration);
        resolve = () => {
            clearTimeout(timeoutId);
            resolver();
        };
    });
    promise.resolve = resolve;
    return promise;
}
